import lightFormat from 'date-fns/lightFormat';
import { EInternalPackageType, TPayPackageData } from '../../../../../PayPackageMicrofrontend';
import { IRecommendedPackage } from '../../../../types/reducers/recommendedPackages';
import { mapService } from './mapService';
import { mapWidgetSource } from './mapWidgetSource';
import { mapGifts } from './gifts';

export const mapBuyPackageData = (recommendedPackage: IRecommendedPackage): TPayPackageData => {
  const {
    totalAuctionPoints,
    autoProlong,
    categoriesView,
    discountPercent,
    durationInDays,
    packageStartDate,
    packageEndDate,
    marketingPrice,
    packageId,
    polygonIds,
    price,
    regionNames,
    services,
    type,
  } = recommendedPackage;

  const { cashback, cashbackPercent, gifts } = mapGifts(recommendedPackage.gifts);

  return {
    totalAuctionPoints,
    autoProlong,
    categoriesView,
    discountPercent,
    durationInDays,
    activationDate: lightFormat(new Date(packageStartDate), 'dd.MM.yyyy'),
    endDate: lightFormat(new Date(packageEndDate), 'dd.MM.yyyy'),
    marketingPrice,
    packageId,
    polygonIds,
    price,
    regionNames,
    services: services.map(mapService),
    widgetSource: mapWidgetSource(type),

    // FIXME: Нужно присылать эти значения с бека
    autoProlongAvailable: true,
    auctionPoints: null,
    balanceDetails: undefined,
    cashbackPercent,
    cashback,
    gifts,
    internalType: EInternalPackageType.SmartPackage,
    // Используется для определения какой из саксес-скринов нужно показывать
    isPromotionByAuction: true,
  };
};
